
import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { useFormik } from 'formik';
import notifications from '../../utils/notifications';
import * as yup from 'yup';

const {REACT_APP_BASE_BACKEND_URL} = process.env;
const SUGGEST_COURSE_BACKEND_URL = `${REACT_APP_BASE_BACKEND_URL}/api/add-course`


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const validationSchema = yup.object({
  name: yup
    .string()
    .trim()
    .min(2, 'Please enter a valid name')
    .max(50, 'Name is too long')
    .required('This field is required.'),
  email: yup
    .string()
    .trim()
    .email('Please enter a valid email address')
    .required('This field is required.'),
  course_url: yup
    .string()
    .url('This is not a valid url')
    .trim()
    .required('This field is required.'),
  course_name: yup
    .string()
    .trim()
    .min(2, 'Please enter a course name')
    .max(50, 'Name is too long')
    .required('This field is required.'),
  description: yup
    .string()
    .required('This field is required.'),
});

const SuggestCourseDialog = ()=> {
  const [open, setOpen] = React.useState(false);
  const initialValues = {
    name: '',
    email: '',
    course_name: '',
    course_url: '',
    description:''
  };

  const onSubmit = (values) => {
    const token = window.localStorage.getItem('jwt');
    fetch(SUGGEST_COURSE_BACKEND_URL, {
        method: 'POST',
        credentials: 'include',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `${token && `jwt ${token}`}`
        },
        body: JSON.stringify(values)
    }).then(res => {
        if(res.status === 201) {
          // window.location = HOME_URL;
          notifications('Thank you for your sharing!', 'success' )
          handleClose();
          formik.resetForm();
          return;
        }
    }).catch(error => notifications());
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit,
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button variant="outlined" onClick={handleClickOpen}>
        Suggest your favorite Course
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Suggest Your Favorite Course</DialogTitle>
        <DialogContent>

          <form onSubmit={formik.handleSubmit}>
        <Grid paddingY={3} container spacing={4}>
          <Grid item xs={12} sm={6}>

            <TextField
              label="Your Name"
              variant="outlined"
              name={'name'}
              fullWidth
              value={formik.values.name}
              onChange={formik.handleChange}
              error={
                formik.touched.name && Boolean(formik.errors.name)
              }
              helperText={formik.touched.name && formik.errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>

            <TextField
              label="Email"
              variant="outlined"
              name={'email'}
              fullWidth
              value={formik.values.email}
              onChange={formik.handleChange}
              error={formik.touched.email && Boolean(formik.errors.email)}
              helperText={formik.touched.email && formik.errors.email}
            />
          </Grid>
          <Grid item xs={12}>

            <TextField
              label="Course Name"
              variant="outlined"
              name={'course_name'}
              fullWidth
              value={formik.values.course_name}
              onChange={formik.handleChange}
              error={formik.touched.course_name && Boolean(formik.errors.course_name)}
              helperText={formik.touched.course_name && formik.errors.course_name}
            />
          </Grid>
          <Grid item xs={12}>

            <TextField
              label="Course Link"
              variant="outlined"
              name={'course_url'}
              fullWidth
              value={formik.values.course_url}
              onChange={formik.handleChange}
              error={formik.touched.course_url && Boolean(formik.errors.course_url)}
              helperText={formik.touched.course_url && formik.errors.course_url}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Description"
              variant="outlined"
              name={'description'}
              type={'text'}
              fullWidth
              value={formik.values.description}
              onChange={formik.handleChange}
              error={formik.touched.description && Boolean(formik.errors.description)}
              helperText={formik.touched.description && formik.errors.description}
            />
          </Grid>
          <Grid item xs={12} textAlign={'right'}>
            <Button variant={'contained'} type={'submit'}>Submit</Button>
        </Grid>
        </Grid>
      </form>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default SuggestCourseDialog;